// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@components";

import actionCreator from "@modules/shared/actionCreator";
import type { AbsenceReviewTask } from "@modules/shared/reducer/absence-review/types";
import AbsenceReviewView from "./absence-review-view";

type OwnProps = $Exact<{
  task: ?AbsenceReviewTask,
  onCancel: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const AbsenceReviewViewModal = (props: Props) => (
  <Modal className="modal-normal">
    <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
      {props.t("ACTIVITY_HISTORY_ITEM_TITLE", {
        id: (props.task || {}).id,
        type: (props.task || {}).type ? props.t((props.task || {}).type) : "",
      })}
    </ModalHeader>
    <ModalBody>
      <AbsenceReviewView task={props.task} />
    </ModalBody>
    <ModalFooter>
      <Button onClick={props.onCancel}>{props.t("CANCEL")}</Button>
    </ModalFooter>
  </Modal>
);

export default localize()(AbsenceReviewViewModal);
